import {
    LOADING_PLANES,
    SET_ID,
    SET_PLANES,
    SET_DATA_GRUPO,
    SET_GRUPO_PLANES,
    FETCH_GRUPO_BYID,
    FETCH_GRUPO_PLANES,
    SET_DATA_GRUPO_COPY,
    FETCH_PLANES_BYPARAMS,
    FETCH_GRUPO_PLANES_BYID,
    SET_PLANES_DESDE_BUSQUEDA,
    SET_FILTRO_GRUPO_PLANES,
    SET_ID_GRUPO_PLAN,
    RESET_GRUPO_PLANES,
    UPDATE_GRUPO_PLANES_LIST,
    SET_EDITANDO
} from '../actions/types';

const initialState = {
    loadingPlanes: false,
    id: 0,
    planes: [],
    grupoPlanes: [],
    grupoPorId: {},
    dataGrupo: {},
    dataGrupoCopy: {},
    planesDesdeBusqueda: [],
    grupoPlanesBusqueda: [],
    planesPorParametros: [],
    filtro: {},
    editando: false,
}

export default function (state = initialState, action) {
    switch (action.type) {
        case LOADING_PLANES:
            return {
                ...state,
                loadingPlanes: action.payload
            };
        case SET_PLANES:
            return {
                ...state,
                planes: action.payload
            };
        case SET_PLANES_DESDE_BUSQUEDA:
            return {
                ...state,
                planesDesdeBusqueda: action.payload
            };
        case SET_ID:
            return {
                ...state,
                id: action.payload
            };
        case FETCH_GRUPO_PLANES:
            const data = action.payload.data;
            let normalized = data;

            if (data && data.paginationGrupoPlanes) {
                const pag = data.paginationGrupoPlanes;
                normalized = {
                    ...pag,
                    elementos: pag.content || pag.Content || [],
                    cantidadTotal: pag.total || pag.Total || 0,
                    cantidadPagina: pag.pageSize || pag.PageSize || 10,
                    // Mapear elementos dentro de content si es necesario
                };
            }

            return {
                ...state,
                grupoPlanes: normalized
            };
        case SET_ID_GRUPO_PLAN:
            return {
                ...state,
                grupoPlanes: []
            };
        case SET_GRUPO_PLANES:
            return {
                ...state,
                grupoPlanesBusqueda: action.payload
            };
        case FETCH_GRUPO_PLANES_BYID:
            return {
                ...state,
                grupoPorId: action.payload.data
            };
        case FETCH_GRUPO_BYID:
            return {
                ...state,
                dataGrupo: action.payload.data.elementos[0]
            };
        case SET_DATA_GRUPO:
            return {
                ...state,
                dataGrupo: action.payload
            };
        case SET_DATA_GRUPO_COPY:
            return {
                ...state,
                dataGrupoCopy: action.payload
            };
        case FETCH_PLANES_BYPARAMS:
            return {
                ...state,
                planesPorParametros: action.payload
            };
        case SET_FILTRO_GRUPO_PLANES:
            return {
                ...state,
                filtro: action.payload
            };
        case RESET_GRUPO_PLANES:
            return {
                ...state,
                grupoPlanes: []
            };

        case SET_EDITANDO:
            return {
                ...state,
                editando: !!action.payload
            };

        case UPDATE_GRUPO_PLANES_LIST:
            return {
                ...state,
                grupoPlanes: action.payload
            };
        default: return state
    }
}